export default __webpack_public_path__ + "static/media/seat.d2910f44.png";